/** Quoted, and a leading = + - @ made harmless, so text from a form cannot run as a formula in Excel. Same guard as the API's contest export. */
export const csvCell = (value: string | number | boolean | null | undefined): string => {
  const text = value === null || value === undefined ? '' : String(value);
  return `"${(/^[=+\-@\t\r]/.test(text) ? `'${text}` : text).replace(/"/g, '""')}"`;
};
